import { Clock, Instagram, MapPin, Music2, Phone, Sparkles } from "lucide-react";

export default function ContactPage({ contact }) {
  return (
    <section className="page-section contact-page" data-testid="contact-page">
      <ContactIntro />
      <div className="contact-layout">
        <ContactCard contact={contact} />
        <ContactMap contact={contact} />
      </div>
    </section>
  );
}

function ContactIntro() {
  return (
    <div className="page-intro">
      <span className="eyebrow" data-testid="contact-eyebrow">Contacto y ubicación</span>
      <h1 data-testid="contact-title">Ven a hacer tu pausa.</h1>
      <p data-testid="contact-description">Estamos en Plaza Mayor, Ciempozuelos. Puedes consultar el horario, abrir el mapa o reservar tu mesa por WhatsApp.</p>
    </div>
  );
}

function ContactCard({ contact }) {
  const encodedAddress = encodeURIComponent(contact.address);
  const mapsUrl = contact.maps_url || `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  const whatsappReady = Boolean(contact.phone) && !contact.phone.toLowerCase().includes("pendiente");
  const whatsappHref = whatsappReady ? `https://wa.me/${contact.phone.replace(/[^0-9]/g, "")}` : undefined;

  return (
    <div className="contact-card" data-testid="contact-info-card">
      <ContactLine icon={<MapPin />} title="Dirección" value={contact.address} testId="contact-address" />
      <ContactLine icon={<Phone />} title="Teléfono" value={contact.phone} testId="contact-phone" />
      <ContactSocialLine contact={contact} />
      <ContactHours hours={contact.hours} />
      <ContactActions mapsUrl={mapsUrl} whatsappHref={whatsappHref} whatsappReady={whatsappReady} />
    </div>
  );
}

function ContactSocialLine({ contact }) {
  return (
    <div className="contact-line contact-social-line" data-testid="contact-social-line">
      <Instagram />
      <div>
        <h2 data-testid="contact-social-title">Redes</h2>
        <div className="contact-social-buttons" data-testid="contact-social-buttons">
          <a href="https://www.instagram.com/nossabarcafe" target="_blank" rel="noreferrer" data-testid="contact-instagram-button"><Instagram size={17} /> Instagram {contact.instagram}</a>
          <a href="https://www.tiktok.com/@nossabarcafe" target="_blank" rel="noreferrer" data-testid="contact-tiktok-button"><Music2 size={17} /> TikTok {contact.tiktok || contact.instagram}</a>
        </div>
      </div>
    </div>
  );
}

function ContactHours({ hours }) {
  return (
    <div className="contact-line" data-testid="contact-hours-block">
      <Clock />
      <div>
        <h2 data-testid="contact-hours-title">Horario</h2>
        {hours.map((hour, index) => <p key={hour} data-testid={`contact-hours-line-${index}`}>{hour}</p>)}
      </div>
    </div>
  );
}

function ContactActions({ mapsUrl, whatsappReady, whatsappHref }) {
  return (
    <div className="contact-actions" data-testid="contact-actions">
      <a className="contact-action primary" href={mapsUrl} target="_blank" rel="noreferrer" data-testid="contact-google-maps-button"><MapPin size={18} /> Ver en Google Maps</a>
      {whatsappReady ? (
        <a className="contact-action" href={whatsappHref} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-button"><Phone size={18} /> Escribir por WhatsApp</a>
      ) : (
        <span className="contact-action disabled" data-testid="contact-whatsapp-pending"><Phone size={18} /> WhatsApp pendiente</span>
      )}
    </div>
  );
}

function ContactMap({ contact }) {
  const encodedAddress = encodeURIComponent(contact.address);

  return (
    <div className="map-placeholder" data-testid="contact-map-placeholder">
      <iframe title="Mapa de Nossa Bar Café" src={`https://maps.google.com/maps?q=${encodedAddress}&t=&z=16&ie=UTF8&iwloc=&output=embed`} loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-google-map-iframe" />
      <div className="map-caption" data-testid="contact-map-overlay">
        <Sparkles size={22} />
        <h2>Nossa en Ciempozuelos</h2>
        <p>{contact.address}</p>
      </div>
    </div>
  );
}

function ContactLine({ icon, title, value, testId }) {
  return (
    <div className="contact-line" data-testid={`${testId}-line`}>
      {icon}
      <div>
        <h2 data-testid={`${testId}-title`}>{title}</h2>
        <p data-testid={testId}>{value}</p>
      </div>
    </div>
  );
}